import { z } from "zod";

// ─── Nota upload response ─────────────────────────────────────────────────────

export const NotaUploadResponseSchema = z.object({
  invoice: z.object({
    id: z.string().uuid(),
    invoice_number: z.string(),
    invoice_type: z.enum(["sales", "cost"]),
    source: z.literal("nota"),
    issue_date: z.string().date(),
    due_date: z.string().date().nullable(),
    gross_amount: z.string(),
    net_amount: z.string(),
    vat_amount: z.string(),
    vat_rate: z.string().nullable(),
    status: z.literal("unpaid"),
    client_id: z.string().uuid(),
    description: z.string().nullable(),
    nota_r2_key: z.string().nullable(),
  }),
  client: z.object({
    id: z.string().uuid(),
    name: z.string(),
    nip: z.string().nullable(),
    created: z.boolean(),
  }),
  warnings: z.array(z.string()),
});

export type NotaUploadResponse = z.infer<typeof NotaUploadResponseSchema>;
